export const isPathInApp = (pathname: string, appPrefix: string): boolean =>
  pathname === appPrefix || pathname.startsWith(`${appPrefix}/`);
